module.exports = __webpack_public_path__ + "static/media/400076_01.f99c8c3c.png";